import RadioGroupEditInputCell from "components/common/radiogroup-edit-input-cell"
import { rootStore } from "stores/root-store"
import AutocompleteEditInputCell from "components/common/autocomplete-edit-input-cell"
import { GlobalData } from "shared/global-data"
import { CommonHyperlink } from "components/common-styles"
import { formatDisplayDate } from "utils/date-helper"

export const filterData = [
  {
    name: "item_category1",
    text: "Item Category 1",
  },
  {
    name: "item_category2",
    text: "Item Category 2",
  },
  {
    name: "item_category3",
    text: "Item Category 3",
  },
  /*{
    name: "hide_lines_no_soh",
    text: "Hide lines with no SOH",
  },
  {
    name: "including_inventory",
    text: "Including inventory data",
  },*/
]

export const hiddenColumns = {
  PROTECTION_VALUE: false,
  COUNTRY_OF_ORIGIN: false,
  TREAT_AS_LOOSE: false,
  SERIAL_TRACKED: false,
  LOT_CONTROLLED: false,
  ITEM_CATEGORY3: false,
  ITEM_CATEGORY2: false,
  QUANTITY_UM: false,
  WEIGHT_UM: false,
  DIMENSION_UM: false,
}

// Export-only: kept off the products grid, which is master data.
export const exportColumnsExtra = [{ field: "AVAILABLE_TO_SELL", headerName: "Available to Sell", type: "number" }]

export const columnsExtraInventory = [
  {
    field: "LOT",
    headerName: "Lot/batch",
    width: 120,
  },
  {
    field: "EXPIRATION_DATE",
    headerName: "Expiry",
    width: 120,
    renderCell: params => {
      return formatDisplayDate(params.value)
    },
  },
]

export const columns = [
  {
    field: "PRODUCT",
    headerName: "Product",
    flex: 1,
    minWidth: 250,
    renderCell: params => <CommonHyperlink to={`/products/${encodeURIComponent(params.value)}`}>{params.value}</CommonHyperlink>,
  },
  {
    field: "PRODUCT_DESCRIPTION",
    headerName: "Description",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "LENGTH",
    headerName: "Length (M)",
    type: "number",
  },
  {
    field: "WIDTH",
    headerName: "Width (M)",
    type: "number",
  },
  {
    field: "HEIGHT",
    headerName: "Height (M)",
    type: "number",
  },
  {
    field: "DIMENSION_UM",
    headerName: "Dimension UM",
    width: 120,
  },
  {
    field: "WEIGHT",
    headerName: "Weight UM",
  },
  {
    field: "QUANTITY_UM",
    headerName: "Qty UM",
  },
  {
    field: "PACKING_CLASS",
    headerName: "Packing Class",
    width: 150,
  },
  {
    field: "ITEM_CATEGORY1",
    headerName: "Item Category 1",
    width: 150,
  },
  {
    field: "ITEM_CATEGORY2",
    headerName: "Item Category 2",
    width: 150,
  },
  {
    field: "ITEM_CATEGORY3",
    headerName: "Item Category 3",
    width: 150,
  },
  {
    field: "LOT_CONTROLLED",
    headerName: "Lot Controlled",
  },
  {
    field: "SERIAL_TRACKED",
    headerName: "Serial Tracked",
  },
  {
    field: "TREAT_AS_LOOSE",
    headerName: "Treat As Loose",
    width: 150,
  },
  {
    field: "COUNTRY_OF_ORIGIN",
    headerName: "Country of Origin",
    width: 150,
  },
  {
    field: "PROTECTION_VALUE",
    headerName: "Protection Value",
    width: 150,
  },
]

export const columnsUploadFunctionsMap = {
  item: {
    customValidation: (rowId, productCode, allData) => {
      productCode = (productCode || "").toUpperCase()
      const found = GlobalData.ProductListSelection.find(x => x.id.toUpperCase() == productCode)
      if (found) return `${productCode} already exsist`

      return ""
    },
  },
  item_category1: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("ITEM_CATEGORY1").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("ITEM_CATEGORY1").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  item_category2: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("ITEM_CATEGORY2").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("ITEM_CATEGORY2").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  item_category3: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("ITEM_CATEGORY3").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("ITEM_CATEGORY3").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  packing_class: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("PACKING_CLASS").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("PACKING_CLASS").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  serial_num_track_inbound: {
    renderEditCell: params => {
      return <RadioGroupEditInputCell {...params} />
    },
  },
  lot_controlled: {
    renderEditCell: params => {
      return <RadioGroupEditInputCell {...params} />
    },
  },
  serial_num_track_outbound: {
    renderEditCell: params => {
      return <RadioGroupEditInputCell {...params} />
    },
  },
  treat_as_loose: {
    renderEditCell: params => {
      return <RadioGroupEditInputCell {...params} />
    },
  },
  x_ref_item1: {
    customValidation: (rowId, val, allData) => {
      const item = allData.find(x => rowId == x.id)
      if (item?.x_ref_item2 == val) return `Barcode must be unique`

      return ""
    },
  },
  x_ref_item2: {
    customValidation: (rowId, val, allData) => {
      const item = allData.find(x => rowId == x.id)
      if (item?.x_ref_item1 == val) return `Barcode must be unique`

      return ""
    },
  },
  country_of_origin: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("COUNTRY").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("COUNTRY").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  harmonized_code: {
    customValidation: (rowId, val, allData) => {
      const found = rootStore.getOptionsByFilter("HARMONIZED_CODE").find(x => x.value == val)
      if (!found) return `${val} is unavailable.`

      return ""
    },
    renderEditCell: params => {
      return <AutocompleteEditInputCell {...params} options={rootStore.getOptionsByFilter("HARMONIZED_CODE").map(option => ({ label: option.label, id: option.value }))} />
    },
  },
  un_number: {
    customValidation: (rowId, val, allData) => {
      const item = allData.find(x => rowId == x.id)
      if (item?.dg_volume && val == null) return `Missing Value`

      if (val && (val.slice(0, 2) !== "UN" || val.length < 6)) return `Invalid UN Number`

      return ""
    },
  },
  dg_volume: {
    customValidation: (rowId, val, allData) => {
      const item = allData.find(x => rowId == x.id)
      if (item?.un_number && val == null) return `Missing Value`

      return ""
    },
  },
}

export const columnsUpload = [
  {
    field: "Company",
    headerName: "Company",
    width: 100,
    editable: false,
    maxLength: 5,
    required: true,
  },
  {
    field: "item",
    headerName: "Product code",
    width: 200,
    editable: true,
    maxLength: 25,
    required: true,
  },
  {
    field: "description",
    headerName: "Product Description",
    width: 200,
    editable: true,
    maxLength: 100,
    required: true,
  },
  {
    field: "item_category1",
    headerName: "Item Category 1",
    editable: true,
    required: true,
    width: 150,
  },
  {
    field: "item_category2",
    headerName: "** Item Category 2",
    mappings: ["Item Category 2"],
    editable: true,
    width: 150,
  },
  {
    field: "item_category3",
    headerName: "** Item Category 3",
    mappings: ["Item Category 3"],
    editable: true,
    width: 150,
  },
  {
    field: "length",
    headerName: "Length (M)",
    type: "number",
    editable: true,
    required: true,
    maxValue: 5,
    minValue: 0,
  },
  {
    field: "width",
    headerName: "Width (M)",
    type: "number",
    editable: true,
    required: true,
    maxValue: 5,
    minValue: 0,
  },
  {
    field: "height",
    headerName: "Height (M)",
    type: "number",
    editable: true,
    required: true,
    maxValue: 5,
    minValue: 0,
  },
  {
    field: "weight",
    headerName: "Weight (kg)",
    type: "number",
    editable: true,
    required: true,
    maxValue: 2000,
    minValue: 0,
  },
  {
    field: "packing_class",
    headerName: "Packing Class",
    width: 180,
    editable: true,
    required: true,
  },
  {
    field: "serial_num_track_inbound",
    headerName: "Receipt - Serial Capture and Reporting (Y/N)",
    editable: true,
    width: 240,
  },
  {
    field: "lot_controlled",
    headerName: "Lot Controlled (Y/N)",
    editable: true,
    width: 240,
    required: true,
  },
  {
    field: "serial_num_track_outbound",
    headerName: "Despatch - Serial Capture and Reporting (Y/N)",
    editable: true,
    width: 240,
  },
  {
    field: "treat_as_loose",
    headerName: "Pack with Other Items",
    mappings: ["Treat as Loose"],
    editable: true,
    width: 240,
    required: true,
  },
  {
    field: "x_ref_item1",
    headerName: "Barcode 1",
    editable: true,
    maxLength: 25,
    shouldValidateAllRowsAfterChanging: true,
    width: 150,
  },
  {
    field: "x_ref_item2",
    headerName: "Barcode 2",
    editable: true,
    maxLength: 25,
    shouldValidateAllRowsAfterChanging: true,
    width: 150,
  },
  {
    field: "list_price",
    headerName: "** Item List Price",
    mappings: ["Item List Price"],
    type: "number",
    editable: true,
    width: 150,
  },
  {
    field: "country_of_origin",
    headerName: "** Country of Origin",
    mappings: ["Country of Origin"],
    editable: true,
    width: 150,
  },
  {
    field: "harmonized_code",
    headerName: "** Harmonized Code",
    mappings: ["Harmonized Code"],
    editable: true,
    width: 150,
  },
  {
    field: "long_description",
    width: 200,
    headerName: "** Product Export Descriptions",
    mappings: ["Product Export Descriptions"],
    editable: true,
    maxLength: 100,
  },
  {
    field: "un_number",
    headerName: "** Dangerous Goods UN Number",
    mappings: ["Dangerous Goods UN Number"],
    editable: true,
    maxLength: 6,
    width: 200,
    shouldValidateAllRowsAfterChanging: true,
  },
  {
    field: "dg_volume",
    headerName: "** Dangerous Goods item Volume",
    mappings: ["Dangerous Goods item Volume"],
    editable: true,
    maxLength: 6,
    width: 200,
    shouldValidateAllRowsAfterChanging: true,
  },
  {
    field: "protection_value",
    headerName: "Protection Value",
    type: "number",
    editable: true,
    maxValue: 8,
    width: 200,
  },
]

export const reorderedKeys = [
  "un_number",
  "dg_volume",
  "active",
  "country_of_origin",
  "description",
  "harmonized_code",
  "item",
  "item_category1",
  "item_category2",
  "item_category3",
  "item_class",
  "list_price",
  "long_description",
  "lot_controlled",
  "packing_class",
  "serial_num_track_inbound",
  "serial_num_track_outbound",
]

export const detailsKeys = ["action", "conversion_qty", "dimension_um", "protection_value", "height", "length", "quantity_um", "sequence", "treat_as_loose", "weight", "weight_um", "width"]
